<template lang="html">
    <div :class="{'journeys-summary': isSummary}" ref="journey">
    	<div class="journeys-title">
    		行程介绍
    	</div>
        <div class="journeys-tab-hold" v-if="journeyData && journeyData.length > 1">
            <div class="journeys-tab-container" :class="{'journeys-summary': isSummary, 'fixed': !isSummary}" ref="list">
                <ul class="journeys-tab">
                    <li v-for="(journeyItem, j) in journeyData"
                        :class="{'active': journeyItem.journeyId == currentId}"
                        @tap="changeJourney(journeyItem.journeyId, $event)">
                        <span>{{journeyItem.journeyName}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <loading v-if="loading"></loading>
        <div v-if="!loading && data && data.journeyDetail" class="journeys-dt">
            <ul v-if="isSummary">
                <li v-for="(journey, index) in data.journeyDetail">
                    <!--<div class="journeys-dt-head">
                        <span class="journeys-dt-head-day">{{journey.title}}</span>
                        <p class="journeys-dt-head-line">{{journey.subTitle}}</p>
                    </div>-->
                    <div class="journeys-dt-container">
                        <div class="journeys-dt-item">
                            <div class="dt-item-title" >
                            	<span class="dt-icon-summary"><i></i></span>
                            	<span class="dt-item-day">{{journey.title}}</span>
                                <p>{{journey.subTitle}}</p>
             
                            </div>
                            <div class="dt-item-content">
                                <div class="dt-item-scenic">
                                	<dl class="dt-item-table-summary" v-if="journey.poiName && journey.poiName.length">
                                	<dt>
                                	    <span class="dt-icon-t"><i class="icon-attractions1"></i></span>景点：</dt>
	                                <dd>
	                                    {{journey.poiName.join(' - ')}}
	                                </dd>
	                                </dl>
                                    <!--<div class="dt-item-des expand" v-if="journey.content" ref="textContainer" @click="toggleContent">-->
                                    <div class="dt-item-des expand" v-if="journey.content" ref="textContainer">
                                        <div class="J_dtDes dt-item-des-container">
                                            <div class="J_dtContent dt-item-des-content" v-html="journey.content.replace(/\n/g, '<br>')">
                                            </div>
                                        </div>
                                        <!--<div class="J_dtExpand dt-item-des-expand">
                                            <span class="icon-putaway"></span>
                                        </div>-->
                                    </div>
                                    <div :class="getImgClass(journey.images.length)">
                                        <div class="journeys-dt-pic" v-for="(img, i) in journey.images" v-if="i < 4">
                                            <img v-lazy="getUrlFromImg(img)" @click="openPreview(index, i)"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <div v-else class="journeys-dt-container">
                <div class="journeys-dt-item" v-for="(journey, index) in data.journeyDetail">
                    <div class="dt-item-title"> <span class="dt-icon-summary"><i></i></span> <span class="dt-item-day">{{journey.title}}</span>
                        <p>{{journey.subTitle}}</p>
                    </div>
                    <div class="dt-item-content" v-if="journey.poiName && journey.poiName.length">
                        <dl class="dt-item-table-summary">
                            <dt><span class="dt-icon-t"><i class="icon-attractions1"></i></span>景点：</dt>
                            <dd>{{journey.poiName.join('、')}}</dd>
                        </dl>
                    </div>
                    
                </div>
            </div>
        </div>
        <!--<div class="journeys-change" v-if="isSummary && journeyData && journeyData.length">
            <span class="journeys-change-btn" @click="eventTrack('CLICK_INDEX_JOURNEY_DETAIL');openJourneyDetail()">查看行程详情</span>
        </div>-->
        <Previewer :photos="imgList" :start-page="imgIndex" v-show="showPreview" v-on:closePreview="closePreview"></Previewer>
    </div>
</template>

<script>
import IScroll from 'iscroll';
import Loading from '@/components/Loading';
import Previewer from '@/components/Previewer';
import {eventTrack} from '@/business/analy';

let jScroll;

export default {
    name: 'simpleJourney',
    props: {
        isSummary: {
            type: Boolean,
            default: function () {
                return true
            }
        },
        journeyData: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data() {
        return {
            data: null,
            currentId: 0,
            loading: false,
            toolStatus: 0, // 边栏状态 0:显示 1:滚动到详情区 2: 回到顶部
            imgList: [],
            imgIndex: 0,
            showPreview: false
        }
    },
    created() {
        if (this.currentId) {
            let currItem = this.journeyData.filter(item => {
                return item.journeyId === this.currentId;
            });
            if (currItem && currItem.length) {
                this.data = currItem[0];
            }
        } else {
            this.data = this.journeyData[0];
            this.currentId = this.journeyData[0] && this.journeyData[0].journeyId || '';
        }
    },
    mounted() {
        if (this.$refs.list) {
            jScroll = new IScroll(this.$refs.list, {
                scrollX: true,
                scrollY: false,
                tap: true,
                preventDefault: false
            });
        }
        this.bindEvent();
    },
    updated() {
        this.bindEvent();
    },
    destroyed() {
    },
    methods: {
        bindEvent() {
            // 文字超出省略
            (this.$refs.textContainer || []).forEach(el => {
                let className = el.className;
                let contentHeight = 0;
                let limitHeight = 0;
                if (~className.indexOf('dt-item-des')) {
                    limitHeight = 150;
                    contentHeight = el.querySelector('.J_dtContent').offsetHeight;
                }
                if (contentHeight > limitHeight && !~el.className.indexOf('ellipsis')) {
                    el.className += ' ellipsis';
                }
            });
        },
        /**
         * img为对象json字符串，获取url
         * @param  json对象字符串
         */
        getUrlFromImg(str) {
            let img = {};
            try {
                img = JSON.parse(str);
            } catch (e) {
            }
            return this.replaceProtocol(img.imgUrl || '');
        },
        /**
         * 图片1/2/3/4时分别不同展示样式
         */
        getImgClass: function(len) {
            let type = len;
            if (len > 4) {
                type = 4;
            }
            return 'journeys-dt-imgs-' + type;
        },
        /**
         * 展开收起隐藏文字
         */
        toggleContent(event) {
            let className = event.currentTarget.className;
            if (~className.indexOf('ellipsis')) {
                if (~className.indexOf('expand')) {
                    event.currentTarget.className = className.replace(' expand', '');
                } else {
                    event.currentTarget.className += ' expand';
                }
            }
        },
        openJourneyDetail() {
            this.$router.push(this.$route.path + '/journey');
        },
        /**
         * 打开图片预览
         * @param  {[number]} index [行程数组序号]
         * @param  {[number]} start [从第几张图片开始 0..]
         */
        openPreview(index, start) {
            this.imgList = this.data.journeyDetail[index].images.map(img => {
                let temp = {}
                try {
                    temp = JSON.parse(img);
                } catch (e) {
                }
                return this.replaceProtocol(temp.imgUrl || '');
            });
            this.imgIndex = start;
            this.showPreview = true;
        },
        closePreview() {
            this.showPreview = false;
        },
        /**
         * 图片地址转换为https
         */
        replaceProtocol(url) {
            return url ? url.replace(/^http:/g, 'https:') : "";
        },
        /**
         * 切换行程
         * @param  {[number]} journeyId [行程id]
         */
        changeJourney(journeyId, event) {
            let journeyItem;
            // 调整tab位置
            let left = event.currentTarget && event.currentTarget.offsetLeft;
            let right = event.currentTarget && event.currentTarget.offsetLeft + event.currentTarget.offsetWidth;
            if (left + jScroll.absStartX < 0) {
                jScroll.scrollBy(-left - jScroll.absStartX, 0, 100);
            } else if (right + jScroll.absStartX - document.documentElement.offsetWidth > 1) {
                jScroll.scrollBy(document.documentElement.offsetWidth - right - jScroll.absStartX, 0, 100);
            }
            if (this.currentId === journeyId) {
                return;
            }
            journeyItem = this.journeyData.find(item => {
                return item.journeyId === journeyId && item.journeyDetail && item.journeyDetail.length;
            });
            if (journeyItem) {
                this.loading = true;
                this.data = journeyItem;
                this.currentId = journeyId;
                this.$store.dispatch('detail/changeJourneyId', journeyId);
                setTimeout(() => {
                    this.loading = false;
                }, 10)
            } else {
                this.getJourneyById(journeyId);
            }

            eventTrack('CLICK_INDEX_JOURNEY_TAB');
        },
        /**
         * 根据行程id获取行程
         * @param  {[type]} journeyId [行程id]
         */
        getJourneyById(journeyId) {
            this.loading = true;
            this.$store.dispatch('detail/getJourneyInfo', {
                productId: this.$store.state.detail.baseInfo && this.$store.state.detail.baseInfo.productId,
                journeyId
            }).then(data => {
                this.currentId = journeyId;
                this.loading = false;
                this.data = data;
            })
        },

        eventTrack
    },
    components: {
        Loading,
        Previewer
    }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// SimpleJourney.vue